import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

const StyledMain = styled(Box)({
  flexGrow: 1,
  overflowY: 'auto',
});

export default StyledMain;
